/**
 * Formats d'une formation (les mêmes que ceux du devis, cf. services/devis) et
 * règles qui en découlent pour l'agenda.
 */

export const FORMATS_FORMATION = [
  { value: 'intra_presentiel', label: 'Intra présentiel' },
  { value: 'intra_distanciel', label: 'Intra distanciel' },
  { value: 'intra_mixte', label: 'Intra mixte' },
  { value: 'intra_presentiel_ou_distanciel', label: 'Intra présentiel ou distanciel' },
  { value: 'inter_presentiel', label: 'Inter présentiel' },
  { value: 'inter_distanciel', label: 'Inter distanciel' },
];

/** Un format 100 % à distance appelle un lien de visio (Teams). */
export const estDistanciel = (format) => /(^|_)distanciel$/.test(String(format || ''));

/** Le lien est-il un lien Teams ? Par son adresse ou, à défaut, par son libellé. */
export const estLienTeams = (lien) =>
  /teams\.(microsoft|live)\.com/i.test(String(lien?.url || '')) || /teams/i.test(String(lien?.libelle || ''));

/** Libellés proposés pour un lien : choisis dans la liste, ou tapés librement. */
export const LIBELLES_LIEN = [
  'Lien Teams',
  'Visioconférence',
  'Convocation',
  'Programme',
  'Document partagé',
  'Feuille de présence',
];
